module.exports = "<svg id=\"b9961232-b2e2-4532-b17d-c1c2d5f132ac\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><defs></defs><title>Facebook1</title><path class=\"34b3fe85-d336-4ae1-aaec-da55c90f10ff\" d=\"M29,48.25V26.5h2.51c1.38,0,2.76,0,4.13,0,.22,0,.59-.26.62-.44.38-2.65.71-5.3,1.07-8.05H29.08c0-2.35-.13-4.61,0-6.85.12-1.6,1.08-2.36,2.71-2.52,1.29-.13,2.6-.11,3.89-.15.59,0,1.19,0,1.83,0V.88c-.41,0-.81-.13-1.22-.15-3.06-.15-6.13-.55-9.14.36a9.5,9.5,0,0,0-6.9,8.55c-.17,2.44-.12,4.88-.17,7.33,0,.31,0,.61,0,1H12.86v8.49h7.21V48.2Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Facebook1.svg
// module id = 514
// module chunks = 1